<template>
  <div class="items">
    <div
      v-if="loading"
      class="q-pa-md"
    >
      <hr-loading-spinner />
    </div>
    <hr-list
      v-else-if="items.length"
      class="mention-list"
    >
      <hr-list-item
        v-for="(item, index) in items"
        :key="item.user"
        :label="item.userName"
        :caption="getUserRoleLabel(item)"
        clickable
        :active="index === selectedIndex"
        @mouseover="onItemHover(index)"
        @click="selectItem(index)"
      />
    </hr-list>
    <div
      v-else
      class="q-pa-md"
    >
      {{ $t('sessions.modals.callInvite.noUsersAvailable') }}
    </div>
  </div>
</template>

<script>
import { chain } from 'lodash';
import { mapState } from 'pinia';
import { HrList, HrListItem, HrLoadingSpinner } from 'src/design-system';
import { auth } from 'src/store/auth';

export default {
  name: 'MentionList',

  components: {
    HrList,
    HrListItem,
    HrLoadingSpinner,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedIndex: 0,
    };
  },

  computed: {
    ...mapState(auth, ['userPrivilegesList']),

  },

  watch: {
    /*
     todo [vue3-migration]: dont want to change anything here as we want to trigger this watcher only if the
      all the array is reassigned and also this component used as the "tippy" tiptap plugin's content element,
      better do not touch
    */
    items() {
      this.selectedIndex = 0;
    }, // items()
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        this.downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        this.enterHandler();
        return true;
      }

      return false;
    }, // onKeyDown()

    upHandler() {
      this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length;
    }, // upHandler()

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
    }, // downHandler()

    enterHandler() {
      this.selectItem(this.selectedIndex);
    }, // enterHandler()

    onItemHover(index) {
      this.selectedIndex = index;
    }, // onItemHover()

    selectItem(index) {
      const item = this.items[index];

      if (item) {
        this.command({ id: item.user, label: item.userName });
      }
    }, // selectItem()

    getUserRoleLabel(userInfo) {
      return chain(this.userPrivilegesList)
        .find({ value: userInfo.userPrivilege || userInfo.role })
        .get('label', '')
        .value();
    }, // getUserRoleLabel()
  },
};
</script>

<style lang="scss" scoped>
.items {
  border-radius: 0.5rem;
  background: var(--app-surface-container);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1);
}

.mention-list {
  max-height: 370px;
  overflow-y: auto;
}
</style>
